import type { ReactionHeartItemWithImg } from '@module/apis/client-side/reaction-heart/type';
import type { HeartIconItem, HeartInfo, ImageOrderValues } from './type';

const findHeartImage = (heartCount: string, heartData: HeartInfo, imageOrder: ImageOrderValues[]) => {
  for (const order of imageOrder) {
    const data = heartData[order];

    if (Array.isArray(data) && data.length === 0) {
      // eslint-disable-next-line no-continue
      continue;
    }

    const heartInfo: HeartIconItem | undefined = (data as Record<string, HeartIconItem>)[heartCount];

    if (heartInfo) {
      if (heartInfo.image) {
        return { type: order, url: heartInfo.image };
      }
    }
  }

  const defaultData: HeartIconItem | [] = heartData.default;

  if ('image' in defaultData) {
    return { type: 'default', url: defaultData.image };
  }

  return { type: 'default', url: '/img/store/onceCoin282.png' };
};

const findReactionHeartImage = (heartCount: number, heartData: ReactionHeartItemWithImg[]) => {
  for (const heart of heartData) {
    if (heart.coin === heartCount) {
      return heart.img;
    }
  }

  return null;
};

export { findHeartImage, findReactionHeartImage };
